import { useMutation, useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

interface IGetAllSectorsRequest {
    page: number;
    size: number;
    orderByDesc: boolean;
    status: string;
}

interface ISectorResponseDto {
    id: number;
    sectorName: string;
}

type IGetSectorsListResponse = BaseResponse<any>;

async function getAllSectors(data: IGetAllSectorsRequest): Promise<IGetSectorsListResponse> {
    try {
        const response = await axiosInstance.post("/Merchant/ListSector", data);
        return response.data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetAllSectors(data: IGetAllSectorsRequest) {
    return useMutation<any | undefined, Error, IGetAllSectorsRequest>(
        [QueryKeys.GetAllMerchantList, data],
        (data) => getAllSectors(data)
    );
}

export function useGetAllSectorsQuery(data: IGetAllSectorsRequest) {
    return useQuery<IGetSectorsListResponse, Error>(
        [QueryKeys.GetAllMerchantList, data],
        () => getAllSectors(data)
    );
}